<template>
<main class="page page-shell sl-games"><van-nav-bar :title="$t('foorter.video')" class="nav-bar"><template #left><van-icon name="arrow-left" color="#fff" @click="back()" /></template></van-nav-bar><div class="content">
  <section class="sl-hero sl-games-hero"><div><p class="sl-eyebrow">SWEETLOVE · {{ $t('index.Entrance') }}</p><h1>{{ $t('foorter.video') }}</h1><p class="sl-hero-caption">{{ visibleGames.length }} {{ $t('index.Entrance') }}</p></div><div class="sl-hero-orbit" aria-hidden="true"><sl-icon name="game" /></div></section>
  <nav class="filter-card sl-category-nav" :aria-label="$t('foorter.video')"><button v-for="(item,index) in filterOptions" :key="item.key" type="button" class="filter-pill" :class="{active:activeKey===index}" :aria-pressed="activeKey===index" @click="onChange(index)">{{ item.name }}</button></nav>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh"><van-empty v-if="visibleGames.length===0" :description="$t('withdraw.empty_data')" /><div v-else class="sl-game-list"><button v-for="(v,key) in visibleGames" :key="key" class="sl-game-card" type="button" @click="toLottery(v.key,v.id)"><span class="sl-game-number">0{{ key+1 }}</span><span class="sl-game-icon"><img :src="getGameIcon(v,key)" alt="" @error="onGameIconError($event,key)" /></span><span class="sl-game-text"><strong>{{ formatGameName(v.name) || '-' }}</strong><span>{{ formatGameDesc(v.desc) || $t('index.Entrance') }}</span></span><span class="sl-game-go"><sl-icon name="arrow" /></span></button></div></van-pull-refresh>
</div></main>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      gameitem: [],
      lotteryitem: [],
      isLoading: false,
      activeKey: 0,
    };
  },
  computed: {
    filterOptions() {
      const ordered = (Array.isArray(this.lotteryitem) ? this.lotteryitem : [])
        .filter(item => this.entryNumber(item.name) !== 4)
        .slice().sort((a, b) => this.entryNumber(a.name) - this.entryNumber(b.name));
      return [{ key: "all", name: this.$t("index.all") }].concat(ordered);
    },
    visibleGames() {
      return this.gameitem.filter(item => this.entryNumber(item.name) !== 4)
        .slice().sort((a, b) => this.entryNumber(a.name) - this.entryNumber(b.name));
    },
  },
  methods: {
    entryNumber(name) {
      const match = String(name || "").match(/[1-4一二三四]/);
      if (!match) return 0;
      return ({ "一": 1, "二": 2, "三": 3, "四": 4 })[match[0]] || Number(match[0]);
    },
    formatGameName(name) {
      return String(name || "").replace(/投注入口/g, "遊戲入口");
    },
    formatGameDesc(desc) {
      return String(desc || "").replace(/快速进入页面/g, "快速進入頁面");
    },
    localGameIcons() {
      return [
        require("@/assets/bc-img/meigui.png"),
        require("@/assets/bc-img/baihe.png"),
        require("@/assets/bc-img/yanhua.png"),
        require("@/assets/bc-img/qiqiu.png"),
      ];
    },
    getGameIcon(item, index) {
      return item.ico || this.localGameIcons()[index % this.localGameIcons().length];
    },
    onGameIconError(event, index) {
      event.target.src = this.localGameIcons()[index % this.localGameIcons().length];
    },
    back() {
      this.$router.go(-1);
    },
    async onRefresh() {
      try {
        await Promise.all([this.getLotteryItem(), this.fetchGameListByActive()]);
        Toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        if (!id) return;
        this.$router.push({ path: "/Lottery?key=" + key + "&id=" + id });
      }
    },
    getGameItem() {
      return this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = Array.isArray(res.data) ? res.data : [];
        return res;
      });
    },
    fetchGameListByActive() {
      if (this.activeKey === 0) {
        return this.getGameItem();
      }
      return this.$http({
        method: "get",
        data: { class: this.activeKey },
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = Array.isArray(res.data) ? res.data : [];
        return res;
      });
    },
    onChange(index) {
      this.activeKey = index;
      return this.fetchGameListByActive();
    },
    getLotteryItem() {
      return this.$http({
        method: "get",
        url: "lottery_class",
      }).then((res) => {
        this.lotteryitem = Array.isArray(res.data) ? res.data : [];
        return res;
      });
    },
  },
  created() {
    Promise.all([this.getLotteryItem(), this.getGameItem()]);
  },
};
</script>
